import { render, staticRenderFns } from "./LimitErrorModal.vue?vue&type=template&id=1c28d955&scoped=true&"
import script from "./LimitErrorModal.vue?vue&type=script&lang=js&"
export * from "./LimitErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./LimitErrorModal.vue?vue&type=style&index=0&id=1c28d955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28d955",
  null
  
)

export default component.exports